import moment from 'moment';

export default {
  processDrops: function(currentPage, resultsPerPage, drops){
    let processedDrops = [];
    let drop = null;
    for (let index = 0; index < drops.length; index++) {

        // Pagination
        if(index < (currentPage -1) * resultsPerPage) continue;
        if(index >= (currentPage) * resultsPerPage) continue;

        // This drop
        drop = drops[index];

        // Status
        drop.statusType = 'light';
        drop.status = 'booked';
        // Complete
        if(drop.dropComplete) {
            drop.statusType = 'success';
            drop.status = 'drop complete';
        // Pickup complete
        } else if(drop.cancelledDate) {
            drop.statusType = 'danger';
            drop.status = 'cancelled';
        // Pickup complete
        } else if(drop.pickupComplete) {
            drop.statusType = 'yellow';
            drop.status = 'pickup complete';
        // 
        } else if(drop.started) {
            drop.statusType = 'info';
            drop.status = 'started';
        }

        // Date
        drop.dateString = moment(new Date(drop.date)).format('D/MM');
        if(drop.dropComplete){
            drop.completeDateString = moment(new Date(drop.dropComplete)).format('h:mm a');
        }else{
            drop.completeDateString = '-';
        }

        // Date
        drop.timeString = moment(new Date(drop.date)).format('h:mm a');
        
        // Push drop onto results to be returned
        processedDrops.push(drop);
    }

    return processedDrops;
  }
}